import axios from 'axios'
import Cookies from 'js-cookie'

//接口域名
 // var postUrl = 'http://wlapi.aiyingxiao.com/index.php/v1/';
 // export let baseUrl  = 'http://wlapi.aiyingxiao.com/index.php/v1/';
 // export let uploadUrl = 'http://wlapi.aiyingxiao.com/index.php/v1/common/upload';
  var postUrl = 'https://wlapi.logisguide.com/index.php/v1/';
export let baseUrl  = 'https://wlapi.logisguide.com/index.php/v1/';
 export let uploadUrl = 'https://wlapi.logisguide.com/index.php/v1/common/upload';
 // var postUrl = 'http://wl.com/index.php/v1/'; //tinakj
 // export let baseUrl  = 'http://wl.com/index.php/v1/';
 // export let uploadUrl = 'http://wl.com/index.php/v1/common/upload';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 添加请求拦截器
axios.interceptors.request.use(function(config) {
  //拦截请求头 修改请求参数。
     config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    var postdata = "";
    if ((config.data instanceof FormData) == false) {
        for (var key in config.data) {
            if (config.data[key] instanceof Array) {
                for (var i = 0; i < config.data[key].length; i++) {
                    var keydata = config.data[key][i];
                    if (typeof (keydata) != "string") {
                        keydata = JSON.stringify(keydata);
                    }
                    postdata += (postdata == "" ? "" : "&") + key + "=" + keydata.replace(/&/g, "%26");
                }
            } else {
                var keydata = config.data[key];
                if (typeof (keydata) != "string") {
                    keydata = JSON.stringify(keydata);
                }
                // console.log(key)
                if (typeof(keydata)!='undefined') {
                    postdata += (postdata == "" ? "" : "&") + key + "=" + keydata.replace(/&/g, "%26");
                }
            }
        }
        config.data = postdata;
    }

    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function(res) {
    // 对响应结果做点什么
    // console.log('end...')
    return res;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export function post_(url, data, callback, err){

    data.auth_key = localStorage.getItem('key')?localStorage.getItem('key'):''
    data.locale_lang= Cookies.get('language');

    // var qs = require("querystring")
    // data = qs.stringify(data, { indices: false,arrayFormat: 'brackets'});
    axios.post(postUrl+url,data)
        .then((response)=>{
            if(response.data.code == 404){
                localStorage.clear();
                location.replace("#/Login")
                return
            }
            callback(response.data)
        })
        .catch(function (error) {
            console.log(error);
            // err(error);
        });
}


export function post2(url, data, callback, err){

    data.auth_key = localStorage.getItem('key')?localStorage.getItem('key'):''
    data.locale_lang= Cookies.get('language');
    axios.post(postUrl+url,data)
        .then((response)=>{
            if(response.data.code == 404){
                localStorage.clear();
                location.replace("#/Login")
                return
            }
            callback(response.data)
        })
        .catch(function (error) {
            console.log(error);
            err(error);
        });
}

export function ajax_upload(url, params, act)
{
    $.ajax({
        url:postUrl+url,
        data:params,
        type:'POST',
        dataType:'json',
        processData:false,
        contentType : false,
        // async:false,
        success:function(data){
            //$("#alert-bg").fadeOut(2000);
            act(data);
        },
        error:function(e){
            console.log('ajax error:',e);
            act(e.responseText);
        }
    });
}

export function download(url) {


    const elink = document.createElement('a');
   
      elink.style.display = 'none';
      elink.href = url;
      elink.target="_blank";
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);


      
    // var iframe =document.createElement("iframe")

    // iframe.style.display ="none";

    // iframe.src = url;

    // document.body.appendChild(iframe);
}



// WEBPACK FOOTER //
// ./src/components/js/request.js